import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';

/** Vlastní tel. čísla uživatele — backend /api/telefonni-cisla. */
export interface TelefonniCisloData {
  funkce: string;
  jmeno: string;
  telefon: string;
  popis: string;
  /** null = obecné (vidět u všech staveb), jinak jen u dané stavby. */
  stavba_id: number | null;
}

export interface TelefonniCislo extends TelefonniCisloData {
  id: number;
}

const QK = ['telefonni-cisla'] as const;

export function useTelefonniCisla(stavbaId: number | null) {
  return useQuery<TelefonniCislo[]>({
    queryKey: [...QK, stavbaId],
    queryFn: () => api.get<TelefonniCislo[]>(stavbaId ? `/telefonni-cisla?stavba_id=${stavbaId}` : '/telefonni-cisla'),
  });
}

export function useSaveTelefonniCislo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number | null; data: TelefonniCisloData }) =>
      id ? api.put<TelefonniCislo>(`/telefonni-cisla/${id}`, data) : api.post<TelefonniCislo>('/telefonni-cisla', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteTelefonniCislo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete<void>(`/telefonni-cisla/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
